import {APP_INITIALIZER, isDevMode, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoute} from './app.route';
import {AppComponent} from './app.component';
import {HttpClientModule} from "@angular/common/http";
import {NgEventBus} from "ng-event-bus";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {WebAppModule} from "./modules/webapp/web-app.module";
import {UtilityModule} from "./modules/common/modules/utility/utility.module";
import {MatIconModule} from "@angular/material/icon";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ServiceWorkerModule} from '@angular/service-worker';
import {environment} from '../environments/environment';
import {TooltipModule} from "ngx-bootstrap/tooltip";
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {CmsModule} from "./modules/common/modules/cms/cms.module";
import {ToastrModule} from "ngx-toastr";
import {AuthConfigModule} from './auth/auth-config.module';
import {HomeComponent} from './modules/web/pages/home/home.component';
import {AuthService} from "./modules/common/modules/auth/services/auth.service";

export function initializeAuth(authService: AuthService): () => Promise<boolean> {
  return () => authService.initializeForStartup();
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent
  ],
  imports: [
    BrowserModule,
    AppRoute,
    AuthConfigModule,
    UtilityModule,
    CmsModule,
    WebAppModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      positionClass: 'toast-top-center',
    }),
    MatIconModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
    TooltipModule.forRoot(),
    NgbModule,
  ],
  providers: [
    NgEventBus,
    MatSnackBar,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAuth,
      deps: [AuthService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
